import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import useLocales from '../../../hooks/useLocales';
import { useLocation, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { RootState, useDispatch, useSelector } from '../../../redux/store';
import { selectBusinessType } from '../../../redux/slices/millSheetSearch';
import getOptionsSelectOptions from '../../../utils/getOptionsSelectOptions';
import getBusinessTypeInSearchParams from '../../../utils/mill-sheet-search/getBusinessTypeInSearchParams';
import { BUSINESS_TYPE } from '../../../constants';
import type { BusinessType, SelectOption } from '../../../types/common';

const SelectBusinessType = (): React.ReactElement => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const { currentLang } = useLocales();
  const { businessType } = useSelector((state: RootState) => state.options);

  const options = getOptionsSelectOptions(businessType, currentLang.value);
  const defaultOption: SelectOption<BusinessType> = {
    label: currentLang.value === 'ja' ? '国内' : 'DOMESTIC',
    value: BUSINESS_TYPE.DOMESTIC,
  };
  const [selectedOption, setSelectedOption] = useState<SelectOption<BusinessType>>(defaultOption);

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // 選択状態が変わったら状態を変更する
  useEffect(() => {
    dispatch(selectBusinessType(selectedOption.value));
  }, [selectedOption]);

  // URLが変わったら必要に応じて選択状態を変更する
  useEffect(() => {
    if (businessType.length > 0) {
      const params = new URLSearchParams(location.search);
      const q = decodeURIComponent(params.get('q'));
      const businessTypeInSearchParams: BusinessType | undefined = getBusinessTypeInSearchParams(q);
      const selected: SelectOption<BusinessType> | undefined = options.find((option) => option.value === businessTypeInSearchParams);
      if (selected) {
        setSelectedOption(selected);
      } else {
        setSelectedOption(defaultOption);
      }
    }
  }, [businessType, location.search]);

  // EVENT HANDLER
  // ================================================================================
  /**
   * プルダウンから区分を選んだときはURLを変えるだけ
   */
  // const handleBusinessTypeChange = (option: SelectOption<BusinessType>): void => {
  //   // console.log(option);
  //   const params = new URLSearchParams(location.search);
  //   const q = decodeURIComponent(params.get('q'));
  //   const queryItems: string[] = q !== 'null' ? q.split(' AND ') : [];
  //   // Languageのクエリを取り除いておく
  //   const exceptLanguage: string[] = queryItems.filter((query) => query.indexOf('Language:') === -1);
  //   // 選択された選択肢からLanguageのクエリを作成
  //   const selectedBusinessType: BusinessType = option.value;
  //   const language: string = selectedBusinessType === BUSINESS_TYPE.EXPORT ? 'EN' : 'JP';
  //   const languageQuery: string = 'Language:' + language;
  //   const newSearchParam: string = [languageQuery, ...exceptLanguage].join(' AND ');
  //   // console.log(q, queryItems, exceptLanguage, languageQuery);
  //   // URLを変更する
  //   params.set('q', encodeURIComponent(newSearchParam));
  //   history.push({ search: params.toString() });
  // };
  const handleBusinessTypeChange = (option: SelectOption<BusinessType>): void => {
    // console.log(option);
    setSelectedOption(option);
  };

  // VIEW
  // ================================================================================

  return (
    <>
      <div id="selectBusinessTypeContainer" className="w-100 d-flex align-items-center">
        <label className="mb-0" htmlFor="selectBusinessType">
          {t('businessType')}：
        </label>
        <div className="flex-fill mr-4">
          <Select
            inputId={'selectBusinessType'}
            name={'selectBusinessType'}
            value={selectedOption}
            options={options}
            onChange={handleBusinessTypeChange}
            placeholder={t('dropdown.default')}
            className="react-select-container"
            classNamePrefix="react-select"
          />
        </div>
      </div>
    </>
  );
};

export default SelectBusinessType;
